import React from "react";
import { Route } from "react-router-dom";
import { GlobalStore } from "../stores/global";
import { removeTrailingSlash } from "./strings";
import URI from "urijs";
import Three0One from "../components/301";

const AuthorizedRoute = props => {
  const {
    currentCountryCode,
    structure: { redirects }
  } = GlobalStore.useState(c => c);

  /**** This compoment ensure the pathname redirects for the / route and other redirects fetched from Strapi ****/
  /**** It is assumed that this component only deals with routes that include a country segment ****/

  const location = window.location.href;
  const trimmedLocation = removeTrailingSlash(location);
  const currentPathname = new URI(location).pathname();
  const countrySegment = new URI(location).segment(0);

  let redirect = null;
  if (currentPathname === "/" || countrySegment.toUpperCase() !== currentCountryCode)
    redirect = `/${currentCountryCode.toLowerCase()}`;
  else {
    const foundRedirect = redirects.find(r =>
      r.source.match(
        `${trimmedLocation.replace(/[()[\]]/g, "")}${r.ignoreTrailingSlash ? "($|/$)" : "$"}`.replace(
          /([*+?])(?:[*+?]*)([*+?])/g,
          "\\$1$2"
        )
      )
    );

    if (foundRedirect) redirect = removeTrailingSlash(foundRedirect.destination);
    else if (location !== trimmedLocation) redirect = trimmedLocation;
  }
  return redirect ? (
    <Three0One
      to={new URI(redirect).pathname().replace(":country", currentCountryCode.toLowerCase())}
      from={location}
    />
  ) : (
    <Route {...props} />
  );
};

export default AuthorizedRoute;
